import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import SEO from "@/components/SEO";
import { staticRoutes, SITE_URL } from "@/seo/routeMeta";
import { organizationSchema, webSiteSchema, generateFAQSchema } from "@/seo/schemas";

const homepageFAQs = [
  {
    question: "What types of RO membranes does AquaQuote sell?",
    answer: "AquaQuote sells industrial and commercial reverse osmosis membranes from leading brands including DuPont FilmTec, Hydranautics, Toray, and LG Chem. Sizes range from residential 2.5\" x 40\" to industrial 8\" x 40\" elements.",
  },
  {
    question: "What pressure vessel brands are available?",
    answer: "AquaQuote carries FRP pressure vessels from Codeline, Pentair, and Wave Cyber. Vessel diameters include 2.5\", 4\", 6\", and 8\" with pressure ratings up to 1200 PSI.",
  },
  {
    question: "How can I get a quote?",
    answer: "Contact AquaQuote directly via phone (+1 858-815-6800), email (orders@aquaquote.com), or through the website. Response time is typically within 24 hours.",
  },
];

const Index = () => {
  const meta = staticRoutes['/'];
  
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title={meta.title}
        description={meta.description}
        canonical={meta.canonical}
        schema={[organizationSchema, webSiteSchema, generateFAQSchema(homepageFAQs)]}
      />
      <Header />
      <main>
        <Hero />
      </main>
      
      <footer className="border-t py-12 px-4 bg-muted/30">
        <div className="container mx-auto max-w-6xl">
          <div className="grid md:grid-cols-3 gap-8 text-center md:text-left mb-8">
            <div>
              <h2 className="font-semibold text-lg mb-3">Contact Us</h2>
              <p className="text-muted-foreground mb-2">Phone/SMS/WhatsApp: <a href="tel:+18588156800" className="hover:text-primary transition-colors">+1 858-815-6800</a></p>
              <p className="text-muted-foreground">Email: <a href="mailto:orders@aquaquote.com" className="hover:text-primary transition-colors">orders@aquaquote.com</a></p>
            </div>
            <div>
              <h2 className="font-semibold text-lg mb-3">About AquaQuote</h2>
              <p className="text-muted-foreground mb-2">12 years in business</p>
              <p className="text-muted-foreground">Headquartered in San Diego, CA</p>
              <p className="text-muted-foreground">Multiple warehouse locations</p>
            </div>
            <nav aria-label="Industries we serve">
              <h2 className="font-semibold text-lg mb-3">Industries We Serve</h2>
              <p className="text-muted-foreground text-sm leading-relaxed">
                Food & Beverage • Agriculture • Manufacturing • System Builders • Service & Maintenance • Water Treatment • Pharmaceutical
              </p>
            </nav>
          </div>
          <nav aria-label="Quick links" className="flex flex-wrap justify-center gap-4 mb-6 text-sm">
            <a href="/products" className="text-muted-foreground hover:text-primary transition-colors">Products</a>
            <a href="/ro-membranes" className="text-muted-foreground hover:text-primary transition-colors">RO Membranes</a>
            <a href="/pressure-vessels" className="text-muted-foreground hover:text-primary transition-colors">Pressure Vessels</a>
            <a href="/about" className="text-muted-foreground hover:text-primary transition-colors">About</a>
            <a href="/contact" className="text-muted-foreground hover:text-primary transition-colors">Contact</a>
            <a href="/blog" className="text-muted-foreground hover:text-primary transition-colors">Blog</a>
          </nav>
          <div className="text-center pt-6 border-t border-border/40">
            <p className="text-sm text-muted-foreground">© {new Date().getFullYear()} AquaQuote. Industrial & Commercial RO Membranes and Pressure Vessels.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Index;
